import React from 'react'

import {
  formatEventStartShort,
  getStartDateFormatter,
  isEventStartTbd,
} from '../../utilities/helpers'

import Card from 'react-bootstrap/Card'
import Stack from 'react-bootstrap/Stack'

// used on package venue profile and my events details
export default function PackageEvent({
  event,
  venue,
  timezone,
  styles,
  children,
}) {
  return (
    <Card className={`card-list card-list--light ${styles || ''}`}>
      <Card.Body>
        <Stack className="card-date align-self-center">
          {isEventStartTbd(event) ? (
            <span className="day normal normal-bold">TBD</span>
          ) : (
            <>
              <span className="month caption--uppercase">
                {formatEventStartShort(event, timezone, 'monthOnly')}
              </span>
              <span className="day normal normal-bold">
                {formatEventStartShort(event, timezone, 'dayOnly')}
              </span>
            </>
          )}
        </Stack>
        <Stack gap={2} className="justify-content-center">
          <Card.Title as="h5" className="card-title-sm mb-0">
            {event?.name}
          </Card.Title>
          <Card.Subtitle as="h6" className="card-subtitle--light">
            <span>
              {formatEventStartShort(
                event,
                timezone,
                getStartDateFormatter(event)
              )}
            </span>
            <span className="venue">{venue?.name}</span>
          </Card.Subtitle>
        </Stack>
        {children}
      </Card.Body>
    </Card>
  )
}
